// extracted by mini-css-extract-plugin
export default {"form":"filters_form__U86iV","button":"filters_button__PKZdI","sidebar":"filters_sidebar__nVP-R","spacer":"filters_spacer__rwX6f"};